<div class="b1-form p-6 bg-white rounded-lg shadow-md">
  <div class="flex justify-between items-center mb-6 pb-4 border-b border-slate-200">
    <h1 class="text-xl font-semibold text-slate-800">
      {{ recordId ? 'Edit Survey' : 'Add Survey' }}
    </h1>
    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="goBack()"
    >
      ← {{ "BACK" | translate }}
    </button>
  </div>

  <form
    [formGroup]="surveyForm"
    (ngSubmit)="onSubmit()"
  >
  <div class="grid grid-cols-12 gap-6">
    <ng-container *ngFor="let field of commonFields">
      <div class="col-span-6" *ngIf="field.type == 'text'">
        <mat-label>{{ field.label }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput [formControlName]="field.key" [type]="field.type" />
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type == 'select'">
        <mat-label>{{ field.label }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select
            [formControlName]="field.key"
            (selectionChange)="field.onChange?.($event.value)"
          >
            <mat-option
              *ngFor="let option of optionsMap[field.optionKey]"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="surveyForm.get(field.key)?.hasError('required')">
            {{ field.label }} is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type == 'textarea'">
        <mat-label>{{ field.label }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <textarea matInput [formControlName]="field.key" rows="1"></textarea>
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type === 'date'">
        <mat-label>{{ field.label }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="picker"
            [formControlName]="field.key"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-container *ngIf="domainFields[selectedDomain]">
      <ng-container *ngFor="let field of domainFields[selectedDomain]">
        <div class="col-span-6">
          <mat-label>{{ field.label }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="field.key" [type]="field.type" />
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div *ngIf="isRoadDomain" class="mt-4 p-4 border border-slate-200 rounded-lg bg-slate-50">
    <div class="flex items-center justify-between mb-3">
      <h3 class="text-sm font-semibold text-slate-700">LRS corridor (optional)</h3>
      <button mat-stroked-button type="button" (click)="openSurveyOnMap()">Open on map</button>
    </div>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-6">
        <mat-label>Route</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="lrsRouteId">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let route of lrsRoutes" [value]="route.id">
              {{ route.route_code }} — {{ route.route_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-span-3">
        <mat-label>From km</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" step="0.001" formControlName="lrsFromKm" />
        </mat-form-field>
      </div>
      <div class="col-span-3">
        <mat-label>To km</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" step="0.001" formControlName="lrsToKm" />
        </mat-form-field>
      </div>
      <div class="col-span-6">
        <mat-label>Chainage label</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput formControlName="lrsChainage" placeholder="e.g. NH-44 @ 45+200" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="mt-6 flex gap-4">
    <button mat-raised-button color="primary" type="submit" [disabled]="saving">
      {{ recordId ? 'Update' : 'Submit' }}
    </button>
    <button mat-button type="button" (click)="onReset()">Reset</button>
  </div>
  </form>
</div>

